<template>
    <div class="pt-3 pb-5">
        <div class="row">
            <div class="col-12">
                <h3>Podgląd</h3>
                <hr>

                <form
                    v-if="form.id"
                    ref="submitForm"
                    @submit.prevent="saveForm($data.form)"
                    enctype="multipart/form-data"
                >
                    <input type="hidden" name="_token" :value="$parent._props.csrf">
                    <div class="form-group">
                        <Select
                            name="number"
                            v-if="data"
                            :options="dataSelect"
                            :selected="form.id"
                            style-select="btn-secondary"
                            :invalid="validMessage ? (validMessage.number ? validMessage.number : null) : null"
                            @select-change-event="ev => {

                                form.id = Number(ev.target.value);
                                form.desc = data[form.id - 1].share_content;
                            }"
                        />
                    </div>
                    <div class="form-group">
                        <InputLabel
                            label="Opis przy udostępnianiu"
                            name="desc"
                            v-if="data"
                            :value="data[form.id - 1].share_content"
                            @input="ev => form.desc = (ev != '' ? ev : null)"

                            :invalid="validMessage ? (validMessage.desc ? validMessage.desc : null) : null"
                        />
                    </div>
                    <div class="form-group">
                        <SunEditor
                            v-if="data"
                            name="content"
                            label="Treść opisu"
                            :value="data[form.id - 1].content"
                            :invalid="validMessage ? (validMessage.content ? validMessage.content : null) : null"
                            @change="val => form.content = val"
                        />
                    </div>

                    <input type="submit" class="btn btn-primary" value="Zapisz">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import InputLabel from '../../ui/InputLable';
    import SunEditor from '../../ui/SunEditor';
    import Select from '../../ui/Select';

    export default {
        data() {
            return {
                token: this.$parent._props.api_token,
                data: null,
                dataSelect: null,
                validMessage: null,
                form:
                {
                    id: null,
                    content: null,
                    desc: null,
                },
                data: null,
                activeNumber: null,
            }
        },
        components: {
            InputLabel, SunEditor, Select
        },
        mounted(){
            axios.defaults.params = {};
            axios.defaults.params['api_token'] = this.token;

            this.$parent._data.loading = false;

            this.fetchData();

        },
        methods: {
            fetchData(){
                let _this = this;
                this.$parent._data.loading = true;
                axios
                .get('/api/get-data', {
                    params:
                    {
                        'option': 'get_numerology',
                    }
                }).then(response => {

                    this.data = response.data;

                    this.createDataForSelect(response.data);

                    if(this.form.id == null)
                    {
                        this.form.id = response.data[0].id;
                        this.form.content = response.data[0].content;
                        this.form.desc = response.data[0].share_content;
                    }

                    $('.loading').animate({
                        opacity: 0,
                    }, 1000, function(){
                        _this.$parent._data.loading = false;
                    })
                });
            },
            createDataForSelect(data){
                this.dataSelect = [];
                for(let i = 0; i < data.length; i++)
                {
                    this.dataSelect.push({
                        value: data[i].id,
                        text: data[i].number
                    });
                }
            },
            saveForm(ev){
                let _this = this;
                this.$parent._data.loading = true;

                axios
                .post('/numberology/save/' + ev.id, ev)
                .then(response => {
                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;

                    this.fetchData();
                })
                .catch(error => {
                        if (error.response.status == 422){
                            this.validMessage = error.response.data.errors;
                            this.$parent._data.message.error = true;
                            this.$parent._data.message.content = 'Uzupełnij pola prawidłowymi danymi!';

                            $('.loading').animate({
                                opacity: 0,
                            }, 1000, function(){
                                _this.$parent._data.loading = false;
                            })
                        }
                    });
            },
        },
    }
</script>
